import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  Menu as MenuIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";

import Logo from "../../../assets/Atithiseva-Logo-Final-1024x298.png";
import profileImage from "../../../assets/istockphoto-2015429231-612x612.jpg";
import { useNavigate } from "react-router-dom";
import "../../../styles/TopBar.css";
import { LOGIN } from "../Routes/AppRoutes";
import { useSelector } from "react-redux";

const TopBar = ({
  isDrawerOpen,
  handleDrawerToggle,
  anchorElUser,
  handleOpenUserMenu,
  handleCloseUserMenu,
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    handleCloseUserMenu();
    navigate(LOGIN);
  };

  const user = useSelector((state) => state.auth.user);

  return (
    <AppBar position="fixed" className="topbar-appbar">
      <Toolbar className="topbar-toolbar">
        <Box className="topbar-logo-container">
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            className="topbar-menu-icon"
          >
            <MenuIcon />
          </IconButton>
          {!isDrawerOpen && (
            <img src={Logo} alt="Admin Logo" className="topbar-logo" />
          )}
        </Box>

        <Box className="topbar-user-container">
          <Box className="topbar-user-info" onClick={handleOpenUserMenu}>
            <Typography variant="body1" className="topbar-user-name">
              {`${user?.first_name} ${user?.last_name}`}
            </Typography>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
